import { createElement } from 'react'
import { Table } from 'shared/components'
import { FlagCell } from 'routes/shared/components'
import { createInWinImage } from 'shared/components/table/cellRenderers'
import { Update } from '../shared/local/components/updateButton'
import { Invoice } from '../shared/local/components/invoiceButton'

// Create common beneficiary control
export const createColumns = () => [
  {
    Header: 'Logo',
    accessor: 'logo',
    Cell: createInWinImage,
    maxWidth: 72,
    width: 72,
  },
  {
    Header: 'Beneficiary Name',
    accessor: 'beneficiaryName',
    sortable: true,
    minWidth: 440,
    width: 440,
  },
  {
    Header: 'Categories',
    accessor: 'category',
    sortable: true,
    Cell: (props) =>
      createElement(Table.CellRenderers.StringListCell, {
        ...props,
      }),
    minWidth: 200,
    width: 200,
  },
  {
    Header: 'Sub Category',
    accessor: 'subCategory',
    sortable: true,
    Cell: (props) =>
      createElement(Table.CellRenderers.StringListCell, {
        ...props,
      }),
    minWidth: 200,
    width: 200,
  },
  {
    Header: 'Jurisdiction',
    accessor: 'jurisdiction.logo',
    sortable: true,
    Cell: FlagCell,
    maxWidth: 120,
    width: 120,
  },
  {
    Header: 'Website',
    accessor: 'website',
    sortable: true,
    Cell: Table.CellRenderers.LinkCell,
    minWidth: 400,
    width: 400,
  },
  {
    Header: 'Member Status',
    accessor: 'active',
    sortable: true,
    Cell: (props) => {
      return createElement(Table.CellRenderers.UserStatusCell, { ...props })
    },
  },
  {
    Header: 'Marketing Promotion',
    accessor: 'marketingPromotion',
    sortable: true,
    Cell: (props) => {
      return props.value ? 'Yes' : 'No'
    },
  },
  {
    Header: 'Update',
    id: 'controls',
    minWidth: 120,
    width: 120,
    accessor: (value) => value,
    Cell: (props) => createElement(Update, { ...props }),
  },
  {
    Header: 'Invoice',
    id: 'controls',
    minWidth: 130,
    width: 130,
    accessor: (value) => value,
    Cell: (props) => createElement(Invoice, { ...props }),
  },
]
